<template>
  <v-dialog scrollable v-model="dialog" max-width="420">
    <v-card>
      <v-card-title class="headline">Tags</v-card-title>
      <v-card-text
        class="text-center text-uppercase font-weight-bold text--secondary"
        v-if="!tags.length"
      >
        Tags not found
      </v-card-text>
      <v-card-text class="pb-0" v-else>
        <v-chip
          small
          label
          class="ma-1"
          color="primary"
          :key="tag.id"
          @click="() => handleTagSelected(tag.id)"
          v-for="tag of tags"
        >
          <v-icon left>mdi-label</v-icon>
          {{ tag.name }}
        </v-chip>
      </v-card-text>
      <v-card-text class="pb-0" v-if="!isPickerMode">
        <v-col class="pb-0">
          <p class="title flex-grow-1 ma-0 black--text">Add new tag:</p>
        </v-col>
        <v-col class="pt-0" cols="12">
          <v-form class="d-flex align-center" ref="tagForm">
            <v-text-field
              class="mr-4"
              counter="255"
              label="Tag name"
              :disabled="isLoading"
              :rules="newTagNameRules"
              v-model="newTagName"
            />
            <v-btn text :loading="isLoading" @click="handleAddTag">Add</v-btn>
          </v-form>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="accent" @click="handleClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { tagsApiV1 } from '@/api/v1';
import { tagsApiV2 } from '@/api/v2';

export default {
  data() {
    return {
      dialog: false,
      tags: [],
      isLoading: false,
      newTagName: '',
      newTagNameRules: [
        (v) => !!v || 'Name is required',
        (v) => v?.length <= 255 || 'Name must be less than 255 characters'
      ],
      isPickerMode: false
    };
  },
  methods: {
    async open(isPickerMode) {
      this.dialog = true;
      this.isPickerMode = isPickerMode;
      this.isLoading = true;
      this.tags = await (
        this.$store.getters.isMatcherApiV2Enabled ? tagsApiV2 : tagsApiV1
      ).fetchTags();
      this.isLoading = false;
    },
    handleClose() {
      this.dialog = false;
    },
    async handleAddTag() {
      const isFormValid = this.$refs.tagForm.validate();

      if (isFormValid) {
        this.isLoading = true;
        const tag = await (
          this.$store.getters.isMatcherApiV2Enabled ? tagsApiV2 : tagsApiV1
        ).createTag(this.newTagName);

        this.tags.push(tag);
        this.$refs.tagForm.reset();
        this.isLoading = false;

        this.$emit('onTagAdded', tag);
      }
    },
    handleTagSelected(tagId) {
      if (this.isPickerMode) {
        this.$emit('onTagSelected', tagId);
        this.handleClose();
      }
    }
  }
};
</script>
